

export default {
  // 项目和标签列表用的cell
  name: 'ProjectCell',
  components: {},
  props: {
    iconClass: String,
    iconColor: String,
    label: String,
    isCollect: Boolean,
    collect: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {}
};